import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import BackImage from "../../../assets/banner.png";
import useServices from '../../../hooks/useServices';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@mui/material';
import SkeletonChildren from '../../common/skelton/skeleton-two';
import Skeleton from '@mui/material/Skeleton'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'

const StyledLink = styled.a`
  color: black;
  text-decoration: none;
  font-size: 16px; /* Increased font size */

  &:hover {
    color: #990000;
    text-decoration: none;
    font-size: 16px; /* Increased hover font size */
    font-weight:600;
    cursor: pointer;
  }
`;

const BannerContainer = styled.section`
  display: flex;
  justify-content: flex-start;
  position: relative;

  background-image: ${({ showBg }) => (showBg ? `url(${BackImage})` : "none")};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  padding: 0;
  height: 350px;

  @media (max-width: 579px) {
    min-height: 400px;
    padding: 0 15px;
    background-image: none;
  }
`;


const SectionContent = styled.section`
  max-width: 700px;
  margin-left: 7%; /* Align to the left */
  width: 100%; /* Ensure it takes full width up to max-width */

  @media (max-width: 768px) {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0 12px 20px 12px;
  }

  @media (max-width: 579px) {
    padding: 0 8px 24px 8px;
  }
`;

const ListContainer = styled.div`
  margin: 0; /* Add some spacing between items */
  padding: 6px 4px;
  height: 32px;
  display: flex;
  align-items: center;

  @media (max-width: 579px) {
    padding: 8px 2px;
    min-height: 28px;
  }
`;

export default function SectionTwoComponentTesting({ initialData, isLoading,isloadingApprovalList = false, isLoadingRecommendationList = false }) {
  const [service] = useServices();
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [approvalList, setApprovalList] = useState([]);
  const [recomandationList, setRecomandationList] = useState([]);

useEffect(()=>{
  if(initialData.length !== 0){
    const sortedApproval = initialData?.approvalList?.sort((a, b) => a.priorityNo - b.priorityNo);
    setApprovalList(sortedApproval);

    const sortedRecomandation = initialData?.recommendationList?.sort((a, b) => a.priorityNo - b.priorityNo);
    setRecomandationList(sortedRecomandation);
  }

},[initialData]);

// Simple fade mount helper (small, local copy)
function useFadeMountedLocal(flag, delay = 300) {
  const [mounted, setMounted] = useState(flag)
  const [visible, setVisible] = useState(flag)
  useEffect(() => {
    let t
    if (flag) {
      setMounted(true)
      requestAnimationFrame(() => setVisible(true))
    } else {
      setVisible(false)
      t = setTimeout(() => setMounted(false), delay)
    }
    return () => clearTimeout(t)
  }, [flag, delay])
  return { mounted, visible }
}

function FadeBox({ show, children, style }) {
  const { mounted, visible } = useFadeMountedLocal(show)
  if (!mounted) return null
  return (
    <div style={{ transition: 'opacity 240ms ease', opacity: visible ? 1 : 0, ...(style||{}) }}>
      {children}
    </div>
  )
}

FadeBox.propTypes = { show: PropTypes.bool }

  const LoadIframe = (url, IsPassRegNoWithURL,IsPassEmailWithURL) => {
    if (IsPassRegNoWithURL) {
      service.setIFrameURL(url + cookies.get('empNo'));
      navigate("/apply-application");
    }else if (IsPassEmailWithURL) {
      service.setIFrameURL(url + cookies.get('sjpEmail'));
      navigate("/apply-application");
    } else {
      service.setIFrameURL(url);
      navigate("/apply-application");
    }
  }

  return (
    <>
      <BannerContainer showBg={(isloadingApprovalList == true && isLoadingRecommendationList == true) ? false : true}>
        <Fragment>
          <SectionContent>
            <div className="container mt-5">
              <div className="row">
                {(approvalList.length > 0 || isloadingApprovalList) && (
                  <div className="col-sm-6">
                    <div>
                     
                      {isloadingApprovalList ? (
                        <FadeBox show={true}>
                          <Box sx={{ minHeight: { xs: 160, sm: 220 } }}>
                            <Skeleton
                              variant="text"
                              animation="wave"
                              sx={{ width: '70%', height: { xs: 18, sm: 24 } }}
                            />
                            <div style={{ height: 8 }} />
                            {Array.from({ length: 4 }).map((_, idx) => (
                                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                  <Skeleton variant="circular" animation="wave" sx={{ width: { xs: 32, sm: 36 }, height: { xs: 32, sm: 36 }, flexShrink: 0 }} />
                                  <Box sx={{ ml: 2, width: '100%' }}>
                                    <Skeleton animation="wave" sx={{ width: { xs: '60%', sm: '70%' }, height: { xs: 11, sm: 14 } }} />
                                    <Skeleton animation="wave" sx={{ width: { xs: '40%', sm: '50%' }, height: { xs: 10, sm: 12 } }} />
                                  </Box>
                                </Box>
                              ))}
                            
                          </Box>
                        </FadeBox>
                      ) : (
                        <>
                         <h4 style={{ marginLeft: 5 }}>Approvals</h4>
                          <div style={{ height: 8 }} />
                          {approvalList?.map((item) => (
                            <ListContainer key={item?.name}>
                              <StyledLink onClick={() => LoadIframe(item?.navigate, item?.IsPassRegNoWithURL,item?.IsPassEmailWithURL)}>
                                  {item?.isShowCount ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ paddingRight: 20 }}>{item?.name}</span>
                                        <Badge color="error" badgeContent={`${item.count}`}>
                                          <span />
                                        </Badge>
                                      </div>
                                    ) :(
                                      <span>{item?.name}</span>
                                    )}
                              </StyledLink>
                            </ListContainer>
                          ))}
                        </>
                      )}
                      
                    </div>
                  </div>
                )}
                
                
                {(recomandationList.length > 0 || isLoadingRecommendationList) && (
                    <div className="col-sm-6">
                      <div>
                        
                        {isLoadingRecommendationList ? (
                          <FadeBox show={true}>
                            <Box sx={{ minHeight: { xs: 160, sm: 220 } }}>
                              <Skeleton
                                variant="text"
                                animation="wave"
                                sx={{ width: '65%', height: { xs: 18, sm: 24 } }}
                              />
                              <div style={{ height: 8 }} />
                              {Array.from({ length: 4 }).map((_, idx) => (
                                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                  <Skeleton variant="circular" animation="wave" sx={{ width: { xs: 32, sm: 36 }, height: { xs: 32, sm: 36 }, flexShrink: 0 }} />
                                  <Box sx={{ ml: 2, width: '100%' }}>
                                    <Skeleton animation="wave" sx={{ width: { xs: '60%', sm: '70%' }, height: { xs: 11, sm: 14 } }} />
                                    <Skeleton animation="wave" sx={{ width: { xs: '40%', sm: '50%' }, height: { xs: 10, sm: 12 } }} />
                                  </Box>
                                </Box>
                              ))}
                            </Box>
                          </FadeBox>
                        ) : (
                          <>
                          <h4 style={{ marginLeft: 5 }}>Recommendations</h4>
                            <div style={{ height: 8 }} />
                            {recomandationList?.map((item) => (
                              <Fragment key={item?.name}>
                                {item?.ServiceType === 0 && (
                                  <ListContainer>
                                    <StyledLink onClick={() => LoadIframe(item?.navigate, item?.IsPassRegNoWithURL,item?.IsPassEmailWithURL)}>

                                    {item?.isShowCount ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ paddingRight: 20 }}>{item?.name}</span>
                                        <Badge color="error" badgeContent={`${item.count}`}>
                                          <span />
                                        </Badge>
                                      </div>
                                    ) :(
                                      <span>{item?.name}</span>
                                    )}
 
                                    </StyledLink>
                                  </ListContainer>
                                )}
                                {item?.ServiceType === 2 && (
                                  <ListContainer>
                                    <StyledLink target='_blank' href={item?.navigate}>
                                      
                                    {item?.isShowCount ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ paddingRight: 20 }}>{item?.name}</span>
                                        <Badge color="error" badgeContent={`${item.count}`}>
                                          <span />
                                        </Badge>
                                      </div>
                                    ) :(
                                      <span>{item?.name}</span>
                                    )}

                                    </StyledLink>
                                  </ListContainer>
                                )}
                              </Fragment>
                            ))}
                          </>
                        )}
                      </div>
                    </div>

                )}

                
              </div>
            </div>
          </SectionContent>
        </Fragment>
      </BannerContainer>
    </>
  );
}
